import { Modal } from '@successmode-ktp/kui';
import styled from 'styled-components';

type Props = {
  isOpen: boolean;
  title: string;
  desc: string;
  subBtnTitle: string;
  onClickSubBtn: () => void;
  btnTitle: string;
  isBtnLoading?: boolean;
  onClickBtn: () => void;
};

function PaymentCancelModal({
  isOpen,
  title,
  desc,
  subBtnTitle = '취소',
  onClickSubBtn,
  btnTitle = '결제 취소하기',
  isBtnLoading = false,
  onClickBtn,
}: Props) {
  return (
    <Modal isOpen={isOpen} hasBackdrop>
      <Modal.Header>
        <Title>{title}</Title>
      </Modal.Header>
      <Content>{desc}</Content>
      <Modal.Footer>
        <Button onClick={onClickSubBtn}>{subBtnTitle}</Button>
        <SubmitButton
          onClick={() => {
            onClickBtn();
          }}
        >
          {btnTitle}
          {isBtnLoading && <LoadingSpinner />}
        </SubmitButton>
      </Modal.Footer>
    </Modal>
  );
}

const Title = styled.h4`
  font-size: 21px;
  font-weight: 700;
  color: #030303;
  margin-bottom: 16px;
`;

const Content = styled.p`
  width: 436px;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  color: #5f6165;
  white-space: pre;
`;

const LoadingSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 4px solid rgba(255, 255, 255, 0.5);
  border-top: 4px solid #ffffff;
  border-radius: 50%;
  animation: spin 700ms linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Button = styled.button`
  display: flex;
  height: 52px;
  padding: 14px 0px;
  justify-content: center;
  align-items: center;
  flex: 1;
  border-radius: 8px;
  background: var(--Mono-10, #e5e6e8);
  color: var(--Mono-80, #3a3b3e);
  text-align: center;

  /* WebTitle/16_SB */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 24px */
`;

const SubmitButton = styled(Button)`
  background: var(--KTP-Color-Point-100, #ff2d55);
  color: var(--KTP-Color-Point-0, #ffffff);
  gap: 6px;
  &:hover {
    background-color: #d31b3e;
  }
`;

export default PaymentCancelModal;
